import { Component } from "react";
import "./ServiceLevelsSidebar.scss";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetServiceLevelsDTO from "../../../../models/DTO/IGetServiceLevelsDTO";
import IOnGetServiceLevelsDTO from "../../../../models/DTO/IOnGetServiceLevelsDTO";
import IProcessServiceLevelsDTO from "../../../../models/DTO/IProcessServiceLevelsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import INewServiceLevel from "../../../../models/INewServiceLevel";
import INotification from "../../../../models/INotification";
import IOwTableCols from "../../../../models/IOwTableCols";
import IServiceLevelUI from "../../../../models/IServiceLevelUI";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTable from "../../../shared/OwTable/OwTable";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import * as _ from "lodash-es";
import { Socket } from "socket.io-client";
import { ConfirmDeleteOverlayFn } from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "../../../shared/OwAcceptCancelActions/OwAcceptCancelActions";

type Props = {
    cancelFn: () => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {
    serviceLevels: IServiceLevelUI[];
    hasChanges: boolean;
    confirmDeleteRow: null | IServiceLevelUI;
    sourceElement: string | null;
    hasNewServiceLevel: boolean;
    newServiceLevel: INewServiceLevel;
    columns: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
};

class ServiceLevelsSidebar extends Component<Props, State> {
    deleteOverlay: any = null;

    constructor(props: any) {
        super(props);

        this.state = {
            serviceLevels: [],
            isDataFetching: false,
            isInitialData: true,
            confirmDeleteRow: null,
            sourceElement: null,
            hasChanges: false,
            hasNewServiceLevel: false,
            newServiceLevel: {} as INewServiceLevel,
            columns: [
                {
                    valueProp: "",
                    title: "",
                    isActionsCol: true,
                    renderFn: this.renderActionsFn,
                    renderFnEmitsRow: true,
                },
                {
                    valueProp: "",
                    title: "default",
                    renderFn: this.renderIsDefaultFn,
                    renderFnEmitsRow: true,
                    className: "text-center",
                },
                {
                    valueProp: "",
                    title: "expedited",
                    renderFn: this.renderIsExpeditedFn,
                    renderFnEmitsRow: true,
                    className: "text-center",
                },
                {
                    valueProp: "name",
                    title: "name",
                    renderFn: this.renderNameFn,
                    renderFnEmitsRow: true,
                },
                {
                    valueProp: "",
                    title: "lead_time",
                    renderFn: this.renderLeadTimeFn,
                    renderFnEmitsRow: true,
                    className: "text-center",
                },
            ],
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.SuppliersOnGetServiceLevels, this.onGetServiceLevels);
        this.props.socket.on(EndpointsEnum.SuppliersOnProcessServiceLevels, this.onProcessServiceLevels);

        this.getServiceLevels();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.SuppliersOnGetServiceLevels, this.onGetServiceLevels);
        this.props.socket.removeListener(EndpointsEnum.SuppliersOnProcessServiceLevels, this.onProcessServiceLevels);
    }

    renderActionsFn = (row: IServiceLevelUI, index: number) => {
        return (
            <div>
                <OwDeleteEditActions
                    isEditMode={row.editMode}
                    onTrashClickFn={() => {
                        this.confirmDelete(row, index);
                    }}
                    onEditClickFn={() => {
                        this.toggleEditMode(row);
                    }}
                />
                <OwAcceptCancelActions
                    isEditMode={!row.editMode}
                    onAcceptClickFn={() => {
                        this.toggleEditMode(row);
                    }}
                    onCancelClickFn={() => {
                        this.toggleEditMode(row);
                    }}
                />
            </div>
        );
    };

    renderNameFn = (row: IServiceLevelUI) => {
        return (
            <div>
                {!row.editMode ? (
                    <div>{row.name}</div>
                ) : (
                    <OwInputWrapper
                        name={"name"}
                        fn={(e: any) => {
                            this.handleChange(e, row);
                        }}
                        value={row.name}
                    />
                )}
            </div>
        );
    };

    renderIsExpeditedFn = (row: IServiceLevelUI) => {
        return (
            <div>
                {row.editMode ? (
                    <div>
                        <OwCheckbox
                            checked={row.is_expedited}
                            label={"is_expedited"}
                            fn={(e: any) => {
                                this.handleChange(e, row);
                            }}
                            truthyVal={true}
                            falsyVal={false}
                            name={"is_expedited"}
                        />
                    </div>
                ) : (
                    <div>
                        <i className={row.is_expedited ? "fas fa-rabbit-fast" : ""} />
                    </div>
                )}
            </div>
        );
    };

    renderIsDefaultFn = (row: IServiceLevelUI) => {
        return (
            <div className={"d-flex h-100 justify-content-center align-items-center"}>
                {row.editMode ? (
                    <div>
                        <OwCheckbox
                            checked={row.is_default}
                            label={"is_default"}
                            fn={(e: any) => {
                                this.handleChange(e, row);
                            }}
                            truthyVal={true}
                            falsyVal={false}
                            name={"is_default"}
                        />
                    </div>
                ) : (
                    <i className={row.is_default ? "text-success fas fa-circle-check" : ""} />
                )}
            </div>
        );
    };

    renderLeadTimeFn = (row: IServiceLevelUI) => {
        return (
            <div>
                {!row.editMode ? (
                    <div>{row.lead_time}</div>
                ) : (
                    <OwInputWrapper
                        name={"lead_time"}
                        type={"number"}
                        fn={(e: any) => {
                            this.handleChange(e, row);
                        }}
                        value={row.lead_time}
                    />
                )}
            </div>
        );
    };

    getServiceLevels = () => {
        const payload: IGetServiceLevelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SuppliersGetServiceLevels, payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetServiceLevels = (data: IOnGetServiceLevelsDTO) => {
        let serviceLevels: IServiceLevelUI[] = data.serviceLevels.map((level) => {
            const uiLevel: IServiceLevelUI = {
                ...level,
                editMode: false,
            };

            return uiLevel;
        });

        serviceLevels = _.orderBy(serviceLevels, ["lead_time"], ["asc"]);

        this.setState({
            serviceLevels,
            isDataFetching: false,
            isInitialData: false,
        });
    };

    toggleEditMode = (row: IServiceLevelUI) => {
        const serviceLevels = this.state.serviceLevels;

        for (const serviceLevel of serviceLevels) {
            if (serviceLevel.id === row.id) {
                serviceLevel.editMode = !serviceLevel.editMode;
            }
        }

        this.setState({
            serviceLevels,
        });
    };

    handleChange = (e: any, row: IServiceLevelUI) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const serviceLevels = this.state.serviceLevels;

        for (const serviceLevel of serviceLevels) {
            if (serviceLevel.id === row.id) {
                // @ts-expect-error
                serviceLevel[name] = value;
            }

            if (name === "is_default") {
                if (serviceLevel.id !== row.id && serviceLevel.is_default) {
                    serviceLevel.is_default = false;
                }
            }
        }

        this.setState({
            serviceLevels,
            hasChanges: true,
        });
    };

    confirmDelete = (row: IServiceLevelUI, index: number) => {
        const sourceElement = `row-${index}`;

        this.setState({
            confirmDeleteRow: row,
            sourceElement,
        });
    };

    cancelDelete = () => {
        this.setState({
            confirmDeleteRow: null,
            sourceElement: null,
        });
    };

    commitDelete = () => {
        const serviceLevels = this.state.serviceLevels;

        for (const serviceLevel of serviceLevels) {
            if (serviceLevel.id === this.state.confirmDeleteRow?.id) {
                serviceLevel.deleteFlag = true;
            }
        }

        this.setState(
            {
                serviceLevels,
                hasChanges: true,
                confirmDeleteRow: null,
                sourceElement: null,
            },
            () => {
                this.save();
            }
        );
    };

    save = () => {
        const serviceLevels = this.state.serviceLevels;

        const payload: IProcessServiceLevelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            serviceLevels,
        };

        this.props.socket.emit(EndpointsEnum.SuppliersProcessServiceLevels, payload);
    };

    onProcessServiceLevels = () => {
        const notification: INotification = {
            message: "successfully_processed_service_levels",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                newServiceLevel: {} as INewServiceLevel,
                hasChanges: false,
            },
            () => {
                this.getServiceLevels();
            }
        );
    };

    newServiceLevelChange = (e: any) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const newServiceLevel = this.state.newServiceLevel;

        // @ts-expect-error
        newServiceLevel[name] = value;

        this.setState({
            newServiceLevel,
            hasNewServiceLevel: true,
        });
    };

    addServiceLevel = () => {
        const payload: IProcessServiceLevelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            serviceLevels: [this.state.newServiceLevel],
        };

        this.props.socket.emit(EndpointsEnum.SuppliersProcessServiceLevels, payload);
    };

    render() {
        return (
            <div className="ServiceLevelsSidebar p-2 position-relative">
                <div className={"col-12"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.props.cancelFn}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-rabbit-fast"} title={"service_levels"} />
                    <hr />
                </div>

                <div className={"mb-3"}>
                    <OwLabel title={"create_service_level"} />
                    <div>
                        <div className={"mb-2"}>
                            <OwLabel title={"name"} noBottomMargin={true} />
                            <OwInputWrapper name={"name"} fn={this.newServiceLevelChange} value={this.state.newServiceLevel.name} />
                        </div>

                        <div className={"mb-2"}>
                            <OwLabel title={"lead_time"} noBottomMargin={true} className={"me-2"} />(
                            <OwLabel title={"in_business_days"} noBottomMargin={true} />)
                            <OwInputWrapper
                                name={"lead_time"}
                                type={"number"}
                                fn={this.newServiceLevelChange}
                                value={this.state.newServiceLevel.lead_time}
                            />
                        </div>

                        <div>
                            <OwCheckbox
                                name={"is_expedited"}
                                label={"is_expedited"}
                                truthyVal={true}
                                falsyVal={false}
                                fn={this.newServiceLevelChange}
                                checked={this.state.newServiceLevel.is_expedited}
                            />
                        </div>

                        <div>
                            <OwButton
                                title={"add"}
                                leftIconClass={"fas fa-plus"}
                                fn={this.addServiceLevel}
                                disabled={!this.state.hasNewServiceLevel}
                                disableOnActive={true}
                            />
                        </div>
                    </div>
                </div>

                <div className={"mb-2 position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.sourceElement}
                        message={"confirm_service_level_delete"}
                        handleConfirm={this.commitDelete}
                        handleCancel={this.cancelDelete}
                        skipMainView={true}
                        nestedParentElem={"service-level-table"}
                    />

                    <OwTable
                        id={"service-level-table"}
                        columns={this.state.columns}
                        dataSet={this.state.serviceLevels}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                        tableConfig={{ tableStriped: true }}
                    />
                </div>

                <div className={"d-flex"}>
                    <div>
                        <OwButton title={"save"} fn={this.save} disabled={!this.state.hasChanges} disableOnActive={true} />
                    </div>
                    {this.state.hasChanges ? (
                        <OwLabel className={"text-warning"} leftIconClass={"fa fa-exclimation-triangle"} title={"pending_changes"} />
                    ) : null}
                </div>
            </div>
        );
    }
}

export default ServiceLevelsSidebar;
